const GetContentPillarsDTO = {
    title: "",
    description: ""
};

export default GetContentPillarsDTO;
